import { resolve, useResolve } from '@visiba/instantiation';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { HeaderStateService } from './header_state.service';

interface HeaderVisibility {
	showSearchReception: boolean;
	showMyVisits: boolean;
	showUserProfile: boolean;
	showSignOut: boolean;
}

interface HeaderContextValue {
	visibility: HeaderVisibility;
	setVisibility: (config: Partial<HeaderVisibility>) => void;
	reset: () => void;
}

const DEFAULT_VISIBILITY: HeaderVisibility = {
	showSearchReception: true,
	showMyVisits: true,
	showUserProfile: true,
	showSignOut: true,
};

const HeaderContext = createContext<HeaderContextValue | undefined>(undefined);

export function HeaderProvider({ children }: { children: ReactNode }) {
	const service = useResolve(HeaderStateService);
	const [visibility, setVisibilityState] = useState<HeaderVisibility>(service.visibility.value);

	useEffect(() => {
		setVisibilityState(service.visibility.value);
	}, [service.visibility]);

	const setVisibility = (config: Partial<HeaderVisibility>) => {
		setVisibilityState((prev) => ({ ...prev, ...config }));
	};

	const reset = () => {
		setVisibilityState(DEFAULT_VISIBILITY);
	};

	return <HeaderContext.Provider value={{ visibility, setVisibility, reset }}>{children}</HeaderContext.Provider>;
}

export function useHeader() {
	const context = useContext(HeaderContext);
	if (!context) {
		throw new Error('useHeader must be used within HeaderProvider');
	}
	return context;
}
